import { Button } from "@mui/material";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";

const PaginationControls = ({
    currentPage,
    totalPages,
    onPageChange,
    totalItems,
}) => {
    return (
        <MDBox display="flex" justifyContent="center" alignItems="center" mt={2}>
            <Button
                onClick={() => onPageChange(currentPage - 1)}
                disabled={currentPage === 1}
            >
                Previous
            </Button>

            <MDTypography mx={2} variant="button" fontWeight="regular" color="text">
                Page {currentPage} of {totalPages}
            </MDTypography>

            <Button
                onClick={() => onPageChange(currentPage + 1)}
                disabled={currentPage === totalPages}
            >
                Next
            </Button>
        </MDBox>
    );
};

export default PaginationControls;
